import {useQuery} from "@tanstack/react-query";
import {getList} from "../../../app/getters/getList.js";
import {useSelector} from "react-redux";

export const useListaProcesuSprawozdanie = (rejestrId, enabled = true) => {
    const rola = useSelector((state) => state.user.role);
    const roleParam = rola === 'oper' ? 'oper/' : '';

    return useQuery({
        queryKey: [`lista_procesow_sprawozdanie`, rola, rejestrId],
        queryFn: () => getList(`/${roleParam}sprawozdanie/proces/${rejestrId}`),
        enabled: enabled && !!rejestrId
    })
}
